module.exports = __webpack_public_path__ + "images/application/change-type-e9ba838b.svg";